export default "__VITE_ASSET__e57407af__"